"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { captureAttribution } from "@/lib/attribution";

/**
 * First-touch signup attribution capture across client navigations.
 *
 * Providers alone only mount once, so a param-less first paint followed by a
 * client navigation to `?utm_*` would miss acquisition params. Re-running on
 * pathname/search changes is safe: ``captureAttribution`` never overwrites an
 * existing snapshot.
 */
export function AttributionCapture() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const search = searchParams.toString();

  useEffect(() => {
    captureAttribution();
  }, [pathname, search]);

  return null;
}
